import { gql } from '@apollo/client';
import { UserInfo } from '../../fragments/user/user.fragments';

export const QUERY_USER_ALL_INFO = gql`
  query QueryUserAllInfo($id: ID!) {
    usersPermissionsUser(id: $id) {
      data {
        id
        attributes {
          ...Account
          ...Avatar
          classes {
            data {
              attributes {
                ...Classe
              }
            }
          }
        }
      }
    }
  }
  ${UserInfo.fragments.account}
  ${UserInfo.fragments.avatar}
  ${UserInfo.fragments.classe}
`;

export const QUERY_CACHE_USER_ACCOUNT = gql`
  query QueryCacheInfoAccount($id: ID!) {
    usersPermissionsUser(id: $id) {
      data {
        attributes {
          ...Account
        }
      }
    }
  }
  ${UserInfo.fragments.account}
`;

export const QUERY_USER_ACCOUNT = gql`
  query QueryUserAccount($id: ID!) {
    getUserAccount(userId: $id) {
      id
      ville
      firstname
      username
      lastname
      confirmed
      tel
      email
      shop
      mdp
      avatar {
        name
        id
        media {
          url
        }
      }
      note {
        qteca
        qtepro
        qterebond
        quiz
        qtequiz
        qtevente
        nbvente
        cavente
        venterebond
        moyennegenerale
        pro
      }
      classe {
        id
        name
        operationid
        debut
        fin
        niveau {
          id
          name
        }

        filiere {
          id
          name
        }
        lycee {
          id
          name
        }
      }
    }
  }
`;

export const QUERY_USER_CLASSE = gql`
  query QueryUserClasse {
    getUserClasse {
      name
      debut
      fin
      lycee
      operationid
      id
    }
  }
`;
